import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ChurchService } from 'src/app/church/church.service';
import { GroupService } from 'src/app/group/group.service';
import { MembersService } from 'src/app/members/members.service';
import { User } from 'src/app/shared/interfaces/user.interface';
import { CITIES } from 'src/app/shared/static/cities.json';
import { states } from 'src/app/shared/static/states';
import { AccountService } from '../services/account.service';
import { MembersGetFile } from 'src/app/members/get-file/members-file-send.component';
import { DomSanitizer } from '@angular/platform-browser';
import { CepService } from '../services/cep.service';
import { DialogService } from 'src/app/components/dialog/services/dialog.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
})
export class RegisterComponent implements OnInit {
  form: FormGroup;
  genders = [
    { title: 'Masculino', value: 'M' },
    { title: 'Feminino', value: 'F' },
  ];
  bloods = ['A+', 'B+', 'O+', 'AB+', 'A-', 'B-', 'O-', 'AB-'];
  states = states;
  cities = [];
  groups = [];
  id: number;
  functions = [];
  currentAvatar: string;
  members: User[] = [];
  churches;
  avatar: any;
  avatarData: { blob: any; originalFileName: string };
  originalFile: any;

  constructor(
    private memberService: MembersService,
    private accountService: AccountService,
    private toastr: ToastrService,
    private groupService: GroupService,
    private router: Router,
    private matDialog: MatDialog,
    private churchService: ChurchService,
    private sanitizer: DomSanitizer,
    private cepService: CepService,
    private dialogService: DialogService
  ) {
    //this.states = states;
    this.getGroups();

    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      gender: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(100)]),
      phone_number: new FormControl('', [Validators.required]),
      bhirth_date: new FormControl('', [Validators.required, Validators.maxLength(10)]),
      state_id: new FormControl('', []),
      city_id: new FormControl('', []),
      street: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(100)]),
      home_number: new FormControl('', [Validators.required]),
      complement: new FormControl('', [Validators.maxLength(100)]),
      blood_type: new FormControl('', []),
      cpf: new FormControl('', [Validators.required]),
      group_id: new FormControl('', []),
      discipler_id: new FormControl('', []),
      group_function_id: new FormControl('', []),
      cep: new FormControl('', [Validators.required, Validators.minLength(9)]),
    });
  }

  ngOnInit(): void {
    this.form.get('cep').valueChanges.subscribe((cep) => {
      if (cep.length == 9) {
        this.cepService.get(cep).then((res) => {
          const state = states.find((s) => s.Sigla == res.uf)?.ID;
          this.changeCity(state);
          this.form.patchValue({
            state_id: state,
            city_id: CITIES.find((s) => s.Nome.toLowerCase() == res.localidade.toLowerCase())?.ID,
            street: res.logradouro,
          });
        });
      }
    });
  }

  changeCity(CurrentState): void {
    if (CurrentState) {
      const citiesTemp = CITIES.filter((s) => {
        if (s.Estado == CurrentState) {
          return s;
        }
      });
      this.cities = citiesTemp;
    }
  }

  register(): void {
    if (!this.avatarData || !this.avatarData.blob) {
      this.toastr.error('A foto de perfil é obrigatória!');
      return;
    }

    console.log(this.avatarData.blob.size);

    if (!this.originalFile?.type?.startsWith('image/')) {
      this.toastr.error('Selecione uma imagem válida para a foto do perfil!');
      return;
    }
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    const formData = new FormData();

    formData.append('user_data', JSON.stringify(this.form.value));
    formData.append('name', this.form.get('name').value);
    formData.append('gender', this.form.get('gender').value);
    formData.append('email', this.form.get('email').value);
    formData.append('phone_number', this.form.get('phone_number').value);
    formData.append('bhirth_date', this.form.get('bhirth_date').value);
    formData.append('state_id', this.form.get('state_id').value);
    formData.append('city_id', this.form.get('city_id').value);
    formData.append('street', this.form.get('street').value);
    formData.append('home_number', this.form.get('home_number').value);
    formData.append('complement', this.form.get('complement').value);
    formData.append('blood_type', this.form.get('blood_type').value);
    formData.append('cpf', this.form.get('cpf').value);
    formData.append('group_id', this.form.get('group_id').value);
    formData.append('discipler_id', this.form.get('discipler_id').value);
    formData.append('group_function_id', this.form.get('group_function_id').value);
    formData.append('cep', this.form.get('cep').value);
    formData.append('church_status', 'membro');
    formData.append('avatar', this.avatarData?.blob, this.avatarData?.originalFileName);

    this.accountService
      .registerWithAvatar(formData)
      .then((res) => {
        this.form.reset();
        this.dialogService
          .open({
            title: 'Parabéns!',
            text: 'Cadastro realizado com sucesso!',
            primaryButton: {
              text: 'Confirmar',
              action: () => {},
            },
          })
          .subscribe();
        this.originalFile = null;
        this.avatar = null;
        this.avatarData = {
          blob: null,
          originalFileName: '',
        };
        //this.toastr.success(res.message);
        this.router.navigateByUrl('/cadastrar');
      })
      .catch((err) => {
        console.log(err);
        this.toastr.error(err.error.message || 'Algo de errado aconteceu!');
      });
  }

  getGroups(): Promise<any> {
    return this.groupService
      .getAll()
      .then((res) => {
        this.groups = res;
      })
      .catch((err) => {
        this.toastr.error(err.error.message || 'Falha ao carregar células');
      });
  }

  getChurches() {
    this.churchService
      .get()
      .then((res) => {
        this.churches = res;
      })
      .catch((err) => {});
  }

  changeAvatar() {
    const dialog = this.matDialog
      .open(MembersGetFile, {
        width: '400px',
        height: '600px',
      })
      .afterClosed()
      .subscribe((afterClosedResult) => {
        this.originalFile = afterClosedResult.originalFile;
        const blobUrl = URL.createObjectURL(afterClosedResult.originalFile);
        this.avatar = this.sanitizer.bypassSecurityTrustUrl(blobUrl);
        this.avatarData = afterClosedResult;
      });
  }
}
